import { StateCreator } from 'zustand';
import { DateFilter } from '@/legacy/types';
import dayjs from 'dayjs';
import weekday from 'dayjs/plugin/weekday';

dayjs.extend(weekday);

export type GraphState = {
	selectedDate: string;
	graphXLabels: string[];
	setSelectedDateForGraph: (filter: DateFilter) => void;
};

interface GraphSlice extends GraphState {
	setSelectedDateForGraph: (filter: DateFilter) => void;
}

const initialGraphState: Pick<GraphState, 'selectedDate' | 'graphXLabels'> = {
	selectedDate: 'today',
	graphXLabels: [],
};

export const createGraphSlice: StateCreator<GraphSlice, [], [], GraphState> = (set) => {
	const generateInitialLabels = () => {
		const daysInMonth = dayjs().daysInMonth();
		return Array.from({ length: daysInMonth }, (_, index) =>
			dayjs().startOf('month').add(index, 'days').format('MM/DD/YY'),
		);
	};

	return {
		selectedDate: 'this_month',
		graphXLabels: generateInitialLabels(),
		setSelectedDateForGraph: (filter: DateFilter) => {
			let labels: string[] = [];
			const date = filter.label;

			if (date === 'last_24_hours') {
				labels = Array.from({ length: 24 }, (_, index) =>
					dayjs()
						.subtract(index + 1, 'hours')
						.format('hh:mm A'),
				);
			} else if (date === 'last_7_days') {
				labels = Array.from({ length: 7 }, (_, index) =>
					dayjs()
						.subtract(index + 1, 'days')
						.format('MM/DD/YY'),
				);
			} else if (date === 'last_30_days') {
				labels = Array.from({ length: 30 }, (_, index) =>
					dayjs()
						.subtract(index + 1, 'days')
						.format('MM/DD/YY'),
				);
			} else if (date === 'last_365_days') {
				labels = Array.from({ length: 12 }, (_, index) =>
					dayjs()
						.subtract(index + 1, 'month')
						.format('DD MMM'),
				);
			} else if (date === 'today') {
				const hours = dayjs().hour();
				labels = Array.from({ length: hours + 1 }, (_, index) =>
					dayjs().hour(index).format('hh:mm A'),
				);
			} else if (date === 'this_week') {
				labels = Array.from({ length: 7 }, (_, index) =>
					dayjs().startOf('week').add(index, 'days').format('MM/DD/YY'),
				);
			} else if (date === 'this_month') {
				const daysInMonth = dayjs().daysInMonth();
				labels = Array.from({ length: daysInMonth }, (_, index) =>
					dayjs().startOf('month').add(index, 'days').format('MM/DD/YY'),
				);
			} else if (date === 'this_year') {
				labels = Array.from({ length: 12 }, (_, index) =>
					dayjs().startOf('year').add(index, 'month').format('MMM'),
				);
			}

			set({ selectedDate: date, graphXLabels: labels });
		},

		resetGraphSlice: () => set(initialGraphState),
	};
};
